// The Image Edit list (CREATE group): upload/Redesign-a-Room concepts only.
// HomeSideBar imports this file eagerly, so it must stay import-light.
export const IMAGE_EDIT_LABEL = "Image Edit";

export const IMAGE_EDIT_ROUTE = "/home/image-edit";

// Get started chooser; ?from= names the entry card for analytics.
export const IMAGE_EDIT_START_ROUTE = `${IMAGE_EDIT_ROUTE}/new`;

// Upload page the chooser leads to; ?kind= is the active tab
// (room-photo | sketchup | drawing), ?from= carries the entry card.
export const IMAGE_EDIT_UPLOAD_ROUTE = `${IMAGE_EDIT_ROUTE}/upload`;

// concept.source stamped by the upload flow (useCreateConcept).
export const IMAGE_EDIT_CONCEPT_SOURCE = "UPLOAD";
